import HeroSection from "./components/HeroSection";
import CategoryTabs from "./components/CategoryTabs";
import FeaturedComics from "./components/FeaturedComics";
import LatestUpdates from "./components/LatestUpdates";
import FAQSection from "./components/FAQSection";

export default function Home() {
  const websiteSchema = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "韩漫漫画网",
    url: "https://hanman.cn/",
    description: "无遮韩国免费漫画大全，免费在线阅读韩漫，漫画爱好者聚集的理想之地。",
    potentialAction: {
      "@type": "SearchAction",
      target: "https://hanman.cn/search?q={search_term_string}",
      "query-input": "required name=search_term_string",
    },
  };

  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "韩漫漫画网",
    url: "https://hanman.cn/",
    description: "无遮韩国免费漫画大全 - 免费在线阅读韩漫",
    sameAs: [],
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(websiteSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(organizationSchema)}</script>
      <main>
        <HeroSection />
        <CategoryTabs />
        <FeaturedComics />
        <LatestUpdates />
        <FAQSection />
      </main>
    </>
  );
}